import { render } from "./distpacheditForm.vue?vue&type=template&id=edb6b962&scoped=true"
import script from "./distpacheditForm.vue?vue&type=script&lang=js"
export * from "./distpacheditForm.vue?vue&type=script&lang=js"

import "./distpacheditForm.vue?vue&type=style&index=0&id=edb6b962&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb6b962"]])

export default __exports__